import { RouterModule, Routes } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IndexComponent } from './index.component';
import { MapPageModule } from '../map-page/map-page.module';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { UserAccessManagementModule } from '../user-access-management/user-access-management.module';
import { MessagesModule } from '../messages/messages.module';
import { FormsPageModule } from '../forms-page/forms-page.module';
import { RiskForecastingModule } from '../risk-forecasting/risk-forecasting.module';
import { PrivateSiteGuard } from '@eview/core/guards/private-site.guard';
import { NotificationsComponent } from './notifications.component';
import { ContactUsModule } from '../contact-us/contact-us.module';
import { GetAlertsModule } from '../get-alerts/get-alerts.module';
import { ClickOutsideDirective } from './click-outside.directive';
// import { ClickShowdropdown } from './click-showdropdown.directive';

export const routes: Routes = [
  {
    path: 'login2',
    loadChildren: () => import('../auth/auth.module').then(m => m.AuthModule),
    canActivate: [PrivateSiteGuard]
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('../forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
    canActivate: [PrivateSiteGuard]
  },
  {
    path: 'valida-contrasena',
    loadChildren: () =>
      import('../forgot-password/validate-password.module').then(
        m => m.ValidatePasswordModule
      ),
    canActivate: [PrivateSiteGuard]
  },
  {
    path: 'policy',
    loadChildren: () => import('../policy/policy.module').then(m => m.PolicyModule),
    // canActivateChild: [PrivateSiteGuard]
  },
  {
    path: 'dashboard',
    component: IndexComponent,
    canActivateChild:[PrivateSiteGuard],
    children: [
      {
        path: 'map',
        loadChildren: () => import('../map-page/map-page.module').then(m => m.MapPageModule),
      },
      {
        path: 'map/:type',
        loadChildren: () => import('../map-page/map-page.module').then(m => m.MapPageModule)
      },
      {
        path: 'post/submit',
        loadChildren:
          () => import('../post-editor-page/post-editor-page.module').then(m => m.PostEditorPageModule)
      },
      {
        path: 'posts/analysis',
        loadChildren:
          () => import('../post-filters/post-filters.module').then(m => m.PostFiltersModule)
      },
      {
        path: 'posts/resumen',
        loadChildren:
          () => import('../incidents-summary/incidents-summary.module').then(m => m.IncidentsSummaryModule)
      },
      {
        path: 'analysis-templates',
        loadChildren:
          () => import('../post-analysis/post-analysis.module').then(m => m.PostAnalysisModule)
      },
      {
        path: 'post/edit/:id',
        loadChildren:
          () => import('../post-editor-page/post-editor-page.module').then(m => m.PostEditorPageModule)
      },
      {
        path: 'posts/:type',
        loadChildren: () => import('../data-page/data-page.module').then(m => m.DataPageModule)
      },
      {
        path: 'posts/:type/:id',
        loadChildren: () => import('../data-page/data-page.module').then(m => m.DataPageModule)
      },
      {
        path: 'post/attributes/:id',
        loadChildren:
          () => import('../post-attributes-editor-page/post-attributes-editor-page.module').then(m => m.PostAttributesEditorPageModule)
      },
      {
        path: 'categories/tags',
        loadChildren: () => import('../tags-page/tags-page.module').then(m => m.TagsPageModule)
      },
      {
        path: 'categories/forms-management',
        loadChildren: () => import('../forms-page/forms-page.module').then(m => m.FormsPageModule)
      },
      {
        path: 'settings/user-access-management',
        loadChildren: () => import('../user-access-management/user-access-management.module').then(m => m.UserAccessManagementModule)
      },
      {
        path: 'settings/user-management',
        loadChildren: () => import('../user-management/user-management.module').then(m => m.UserManagementModule)
      },
      {
        path: 'messages',
        loadChildren: () => import('../messages/messages.module').then(m => m.MessagesModule)
      },
      {
        path: 'risk-forecasting',
        loadChildren: () => import('../risk-forecasting/risk-forecasting.module').then(mod => mod.RiskForecastingModule)
      },
      {
        path: 'get-alerts',
        loadChildren: () => import('../get-alerts/get-alerts.module').then(m => m.GetAlertsModule)
      },
      {
        path: 'about-us',
        loadChildren: () => import('../about-us/about-us.module').then(m => m.AboutUsModule)
      },
      {
        path: 'contact-us',
        loadChildren: () => import('../contact-us/contact-us.module').then(m => m.ContactUsModule)
      },
      {
        path: 'categories',
        pathMatch: 'full',
        redirectTo: 'categories/tags'
      },
      {
        path: 'settings',
        pathMatch: 'full',
        redirectTo: 'settings/user-access-management'
      },
      {
        path: 'posts',
        pathMatch: 'full',
        redirectTo: 'posts/analysis'
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'map'
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'map'
      }
    ]
  }
];


@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    NgbModule,
    FontAwesomeModule,
    MapPageModule,
    ContactUsModule,
    GetAlertsModule,
    UserAccessManagementModule,
    MessagesModule,
    FormsPageModule,
    RiskForecastingModule
  ],
  declarations: [IndexComponent, NotificationsComponent, ClickOutsideDirective],
  exports: [IndexComponent, NotificationsComponent]
})
export class IndexModule {}
